import React from 'react'
import PropTypes from 'prop-types'
//import './NavLink.css'

const NavLink = (props) => (
	<a className="NavLink" onClick={props.click}>
		{props.text}
	</a>
)

NavLink.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default NavLink


// WEBPACK FOOTER //
// ./src/components/NavigationComponent/NavLink.js